import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { fetchProducts } from '../lib/products';
import { isSupabaseConfigured } from '../lib/supabaseClient';

export function useProducts() {
  const { loading: authLoading } = useAuth();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(isSupabaseConfigured);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isSupabaseConfigured) {
      setError('Add your Supabase URL and anon key to .env.local to load products.');
      setLoading(false);
      return undefined;
    }

    if (authLoading) {
      return undefined;
    }

    let cancelled = false;

    async function loadProducts() {
      setLoading(true);
      setError('');

      try {
        const data = await fetchProducts();

        if (!cancelled) {
          setProducts(data);
        }
      } catch (loadError) {
        if (!cancelled) {
          setProducts([]);
          setError(
            loadError.message?.includes('permission')
              ? 'Products are not visible for signed-in users. Run supabase-auth-fix.sql in Supabase.'
              : 'Could not load products. Check your Internet connection.'
          );
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    loadProducts();

    return () => {
      cancelled = true;
    };
  }, [authLoading]);

  return { products, loading, error };
}
